module.exports = __webpack_public_path__ + "media/application/images/paradigm-bg-60346ceda6d35f08c9e3f309369af4ed.webp";